"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatLocationWithRoom = exports.formatClient = exports.formatRescheduledLesson = exports.formatReservationLesson = exports.formatFirstLessonDate = exports.formatLessonBasicInfo = exports.formatLesson2 = exports.formatLessonStudentInfo = exports.formatStudentLevel = exports.formatStudentGrade = exports.formatStudentSchool = exports.formatLesson = exports.formatSlot = exports.formatSlotSummary = exports.formatLessonCodeSummary = exports.formatLessonSubjectFromCode = exports.formatLessonTypeFromCode = exports.formatSubjectCode = exports.formatTimestamp = exports.formatMonth = exports.formatWeekday = exports.fullWeekdays = exports.formatDate = exports.formatLocationShort = exports.locationsAbbreviations = exports.formatLocation = exports.locationsFull = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const types_1 = require("../types");
const constants_1 = require("./constants");
exports.locationsFull = {
    [types_1.Location.Lanciego]: 'Natolin, ul. Lanciego 7',
    [types_1.Location.Cynamonowa]: 'Stokłosy, ul. Cynamonowa 47',
    [types_1.Location.Online]: 'Zajęcia online',
};
const formatLocation = (location) => exports.locationsFull[location];
exports.formatLocation = formatLocation;
exports.locationsAbbreviations = {
    [types_1.Location.Lanciego]: 'Lanciego',
    [types_1.Location.Cynamonowa]: 'Cynamonowa',
    [types_1.Location.Online]: 'online',
};
const formatLocationShort = (location) => exports.locationsAbbreviations[location];
exports.formatLocationShort = formatLocationShort;
const formatDate = (date) => (0, dayjs_1.default)(date, 'YYYY-MM-DD').format('DD.MM.YYYY');
exports.formatDate = formatDate;
exports.fullWeekdays = {
    [types_1.Weekday.Mon]: 'poniedziałek',
    [types_1.Weekday.Tue]: 'wtorek',
    [types_1.Weekday.Wed]: 'środa',
    [types_1.Weekday.Thu]: 'czwartek',
    [types_1.Weekday.Fri]: 'piątek',
    [types_1.Weekday.Sat]: 'sobota',
    [types_1.Weekday.Sun]: 'niedziela',
};
const formatWeekday = (day) => exports.fullWeekdays[day];
exports.formatWeekday = formatWeekday;
const formatMonth = (monthNumber) => {
    switch (monthNumber) {
        case 0:
            return 'Styczeń';
        case 1:
            return 'Luty';
        case 2:
            return 'Marzec';
        case 3:
            return 'Kwiecień';
        case 4:
            return 'Maj';
        case 5:
            return 'Czerwiec';
        case 6:
            return 'Lipiec';
        case 7:
            return 'Sierpień';
        case 8:
            return 'Wrzesień';
        case 9:
            return 'Październik';
        case 10:
            return 'Listopad';
        case 11:
            return 'Grudzień';
        default:
            return '';
    }
};
exports.formatMonth = formatMonth;
const formatTimestamp = (timestamp) => {
    const ts = typeof timestamp === 'number' ? (0, dayjs_1.default)(timestamp * 1000) : timestamp;
    return ts.locale('pl').format('ddd, DD.MM.YY H:mm');
};
exports.formatTimestamp = formatTimestamp;
// WARNING: makes assumptions about the data!
/** @deprecated: Use offer.subject instead */
const formatSubjectCode = (subjectCode) => {
    const subCode = subjectCode.includes('warsztaty') ? subjectCode.replace('warsztaty ', '') : subjectCode.split(' ')[0];
    switch (subCode) {
        case 'mat':
            return 'matematyka';
        case 'ang':
            return 'j. angielski';
        case 'pol':
            return 'j. polski';
        case 'fiz':
            return 'fizyka';
        case 'chemia':
            return 'chemia';
        case 'bio':
            return 'biologia';
        case 'his':
            return 'historia';
        default:
            return subCode;
    }
};
exports.formatSubjectCode = formatSubjectCode;
const formatLessonTypeFromCode = (code) => {
    const lessonType = (0, constants_1.getLessonTypeForCode)(code);
    return lessonType !== null && lessonType !== void 0 ? lessonType : 'Zajęcia';
};
exports.formatLessonTypeFromCode = formatLessonTypeFromCode;
const formatLessonSubjectFromCode = (code) => {
    if (!code)
        return '';
    const subjectCode = code.split('_')[0];
    return (0, exports.formatSubjectCode)(subjectCode);
};
exports.formatLessonSubjectFromCode = formatLessonSubjectFromCode;
const formatLessonCodeSummary = (code) => {
    const parts = [
        (0, exports.formatLessonTypeFromCode)(code),
        (0, exports.formatLessonSubjectFromCode)(code),
    ].filter(Boolean);
    return parts.join(' • ');
};
exports.formatLessonCodeSummary = formatLessonCodeSummary;
const formatSlotSummary = (slot) => {
    const parts = [
        slot.code,
        slot.defaultTeacher,
        slot.day ? (0, exports.formatWeekday)(slot.day) : null,
        slot.time,
        slot.duration ? `${slot.duration}min` : null,
    ].filter(Boolean);
    return parts.join(' • ');
};
exports.formatSlotSummary = formatSlotSummary;
const formatSlot = (slot) => {
    return `${slot.code}, ${slot.defaultTeacher}, ${slot.day} ${slot.time} (${slot.duration}min), ${slot.location} (${slot.room})`;
};
exports.formatSlot = formatSlot;
const formatLesson = (lesson) => {
    const locationPart = lesson.location !== types_1.Location.Online
        ? `${lesson.location} (${lesson.room})`
        : lesson.location;
    return `${(0, constants_1.getLessonTypeForCode)(lesson.code)} • ${lesson.teacher} • ${(0, exports.formatSubjectCode)(lesson.code)} • ${(0, dayjs_1.default)(lesson.timestamp * 1000)
        .locale('pl')
        .format('H:mm')} • ${lesson.duration}min • ${locationPart}`;
};
exports.formatLesson = formatLesson;
const formatStudentSchool = (student) => {
    if (!student || !student.school)
        return '';
    switch (student.school) {
        case 'SP':
            return 'podstawówka';
        case 'LIC':
            return 'liceum';
        case 'TECH':
            return 'technikum';
        default:
            return student.school;
    }
};
exports.formatStudentSchool = formatStudentSchool;
const formatStudentGrade = (student) => {
    if (!student || !student.grade)
        return '';
    return `klasa ${student.grade}`;
};
exports.formatStudentGrade = formatStudentGrade;
const formatStudentLevel = (student) => {
    if (!student || !student.level)
        return '';
    switch (student.level) {
        case 'PP':
            return 'p. podstawowy';
        case 'PR':
            return 'p. rozszerzony';
        default:
            return student.level;
    }
};
exports.formatStudentLevel = formatStudentLevel;
const formatLessonStudentInfo = (student) => {
    let info = '';
    if (student.school)
        info += `, szkoła: ${student.school}`;
    if (student.grade)
        info += `, klasa: ${student.grade}`;
    if (student.level)
        info += `, poziom: ${student.level}`;
    return info;
};
exports.formatLessonStudentInfo = formatLessonStudentInfo;
const formatLesson2 = (lesson, timestampOffset = 0) => {
    // eslint-disable-next-line max-len
    return `${(0, exports.formatSubjectCode)(lesson.code)}, ${(0, constants_1.getLessonTypeForCode)(lesson.code)}, ${(0, exports.formatLocation)(lesson.location)}, ${(0, exports.formatTimestamp)(lesson.timestamp + timestampOffset)}, (${lesson.duration} min), korepetytor: ${lesson.teacher}`;
};
exports.formatLesson2 = formatLesson2;
const formatLessonBasicInfo = (lesson) => {
    // eslint-disable-next-line max-len
    return `${(0, exports.formatSubjectCode)(lesson.code)}, ${(0, constants_1.getLessonTypeForCode)(lesson.code)}, 
	${(0, exports.formatLocation)(lesson.location)}, korepetytor: ${lesson.teacher}`;
};
exports.formatLessonBasicInfo = formatLessonBasicInfo;
const formatFirstLessonDate = (lesson) => {
    // eslint-disable-next-line max-len
    // FIXME: very dirty hack for timezone issue, lesson.timestamp is in UTC, but should be in local time
    return `${(0, exports.formatTimestamp)(lesson.timestamp + 7200)}, (${lesson.duration} min)`;
};
exports.formatFirstLessonDate = formatFirstLessonDate;
const formatReservationLesson = (lesson, slot) => {
    // eslint-disable-next-line max-len
    return `${(0, exports.formatSubjectCode)(slot.code)}, ${(0, constants_1.getLessonTypeForCode)(slot.code)}, ${(0, exports.formatLocation)(slot.location)}, ${(0, exports.formatWeekday)(slot.day)}, ${slot.time}, (${slot.duration} min), korepetytor: ${slot.defaultTeacher}, uczestnik: ${lesson.student.name}`;
};
exports.formatReservationLesson = formatReservationLesson;
const formatRescheduledLesson = (lesson) => {
    return `${(0, exports.formatSubjectCode)(lesson.code)}, ${lesson.teacher}, ${(0, exports.formatTimestamp)(lesson.timestamp)}, ${lesson.location}`;
};
exports.formatRescheduledLesson = formatRescheduledLesson;
const formatClient = (client) => {
    return `${client.name} (${client.email})`;
};
exports.formatClient = formatClient;
const formatLocationWithRoom = ({ location, room }) => {
    if (location === types_1.Location.Online || !room)
        return location;
    else
        return `${location} (${room})`;
};
exports.formatLocationWithRoom = formatLocationWithRoom;
